// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"B3-z","displaySixCardTiles":"C3-z"};